import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavComponent } from '../../components/nav.component/nav.component';
import { FooterComponent } from '../../components/footer.component/footer.component';

@Component({
  selector: 'app-privacy.component',
  imports: [
    CommonModule,
    RouterModule,
    NavComponent,
    FooterComponent,
  ],
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.scss',
})
export class PrivacyComponent {
  lastUpdated = 'October 10, 2026';
}
